import i18n from 'services/base/i18n';

export default {
  allowed: () => i18n.pgettext('Enums|Actions', 'Allowed'),
  blocked: () => i18n.pgettext('Enums|Actions', 'Blocked'),
  unknown: () => i18n.pgettext('Enums|Actions', 'Unknown'),
};
